import { isVehicleReadyForBattle } from 'helpers/vehicles'

export const anyOfSelectedVehiclesReady = ({ selected_vehicle_cds, vehicles }) => {
    if (!selected_vehicle_cds || !vehicles.length) return false

    return selected_vehicle_cds.some(vehicle_cd => (
        isVehicleReadyForBattle(vehicles.find(vehicle => vehicle.id === vehicle_cd))
    ))
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/PlayersMatchingButton/helpers.js